<ng-container *t="let t">
    <div class="inside-container" *ngIf="userDetails">
        <div fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start center">
                <h3 class="tab-header" i18n="@@b250a8e6484a786011dac86650b3a222a32f2b62" t="b250a8e6484a786011dac86650b3a222a32f2b62">Address Details</h3>
                <a target="_blank" [href]="helpUrl">
                    <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
                </a>
            </div>
        </div>
      
        <div fxLayout="column" fxLayoutGap="5px" class>
            <p *ngIf="isDataUnderReview">
                <tsl-alert status="warning" class="spacing">
                    <h4 i18n="@@DataUnderReview" t="DataUnderReview">Data Changes Under Tesla Review</h4>
                    <br/>
                    <span i18n="@@DataUnderReviewDescription" t="DataUnderReviewDescription">
                        Submitted data changes are currently under review by Tesla. The ability to self-service in the Tesla Supplier Profile may be limited or restricted while your submission is being reviewed. Other aspects of the Supplier Relationship Management Portal should still be available to you based on your user access.
                    </span>
                </tsl-alert>
            </p>
            <p *ngIf="userDetails.isSupplier">
                <span i18n="@@2147660231888025526" t="2147660231888025526">The Supplier Address Detail is available to users to view or manage their organizations
                    different address locations. Select Supplier Profile data changes will go to Tesla for review and
                    approval for validation purposes.</span>
                <b i18n="@@3175fb1379d3ce0e122b782a8a41f6ac1c07ade7" t="3175fb1379d3ce0e122b782a8a41f6ac1c07ade7">Please Note:</b>
                <span i18n="@@5929170247282831421" t="5929170247282831421">Only your organizations Primary Contact can manage select address details via the portal.
                  You will receive emails in regards to rejections or approval of changes.</span>
            </p>
            <p *ngIf="userDetails.isTeslaUser">
                <span i18n="@@1960daf9864c9fa4a819ab6345ace82faf4561b0" t="1960daf9864c9fa4a819ab6345ace82faf4561b0">The Supplier Address Detail is available to manage organizations different address locations.
                Please go to </span> <a target="_blank" [href]="wsmUrl">warp supplier master</a><span i18n="@@508d2cd7fc189b4a4577ad4d55b0f32dfb1a4797" t="508d2cd7fc189b4a4577ad4d55b0f32dfb1a4797"> to make any changes.</span>
            </p>
            <p *ngIf="showCMTUrl">
                <span i18n="@@f4e14284016536b6d81a961bd35a04ec5fa2d83c" t="f4e14284016536b6d81a961bd35a04ec5fa2d83c">If you have additional questions in regards to this data, click on the hyperlink provided
                    to submit a
                    inquiry to the Tesla Vendor Validation Team. </span><a [href]="cmtUrl">CMT</a>
            </p>
      
        </div>
        <div fxFlex="15" fxLayoutAlign="end center" *ngIf="settings?.showAddressInquiryButton">
            <button tsl-button size="small" color="black" outline
                i18n="@@d40e68bf488debccf44f1e4986015903ae1a370d" t="d40e68bf488debccf44f1e4986015903ae1a370d" 
                tooltip="Please reach out to Supplier Master Data Team if you have further inquiries in regards to your organizations addresses." i18n-tooltip="@@5936333820865907001" #redirectHelpButton tslTooltip="{{ t('5936333820865907001', redirectHelpButton) }}">Address Inquiry</button>
        </div>
      
        <nav class="nav-container" tsl-tab-nav-bar>
            <div class="tsl-tab-header">
                <div class="tsl-tab-label">
                    <div class="tsl-tab-label-content" *ngIf="!preventativeHold">
                        <ng-container *ngFor="let purpose of addressPurpose">
                            <a tsl-tab-link [routerLink]="purpose.name.split(' ').join('')" routerLinkActive
                                #rla="routerLinkActive" [active]="rla.isActive">
                                <div i18n>
                                    {{ translateService.get(purpose.name) }}</div>
                                <a target="_blank" *ngIf="purpose.name==='RemitTo'" [href]="helpUrl">
                                    <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
                                </a>
                            </a>
                        </ng-container>
                    </div>
                </div>
            </div>
        </nav>
        <router-outlet></router-outlet>
      
      
    </div>
</ng-container>
